export enum ExclusionType {
    CrossReference = "CrossReference",
    Spec = "Spec",
    PartSpec = "PartSpec",
    PartPicCode = "PartPicCode",
    PartBrand = "PartBrand",
    Part = "Part",
    CrossOem = "CrossOem",
    PartAlternative = "PartAlternative",
    RelatedPart = "RelatedPart",
    Category = "Category",
    CrossSearch = "CrossSearch",
}
